
<SupplierDetailTable :table-settings="concurrencyTenderTableSettings" :debounce="debounce"
    :sort-options="contractsSortOptions" ref="concurrency_data_table" :enable-search="false" :enable-sort="false"
     @row-clicked="(item) => {
            if (item.is_supplier) {
                $router.push({
                    name: 'supplier-detail',
                    params: {
                        version: version,
                        hash: hash,
                        slug: item.slug
                    }
                });
            }
        }
        ">
    <template v-slot:cell(flags_count)="row">
        <span class="badge badge-pill badge-danger">{{ row.value }}</span>
    </template>

    <template v-slot:cell(flags)="row">
        <FlagDetailRowToggler :row="row" :callback="toggleConcurrencyRowDetail" />
    </template>

    <template v-slot:row-details="row">
        <FlagDetailRow :row="row" :version="version" />
    </template>
</SupplierDetailTable>
